import { API, TOKEN_KEY } from "./api";

/* POST an SSE endpoint and stream tokens: onToken(text), resolves with full reply; throws on error events */
export async function streamAi(path, body, onToken, params = "") {
  const res = await fetch(`${API}${path}${params}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY) || ""}` },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try { detail = (await res.json()).detail || detail; } catch {}
    throw new Error(typeof detail === "string" ? detail : JSON.stringify(detail));
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "", full = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const parts = buf.split("\n\n");
    buf = parts.pop();
    for (const p of parts) {
      const line = p.trim();
      if (!line.startsWith("data:")) continue;
      const data = line.slice(5).trim();
      if (data === "[DONE]") return full;
      try {
        const j = JSON.parse(data);
        if (j.error) throw new Error(j.error);
        if (j.t) { full += j.t; onToken(full, j.t); }
      } catch (e) { if (e.message && !e.message.includes("JSON")) throw e; }
    }
  }
  return full;
}

export const newSessionId = (userId) => `${(userId || "anon").slice(0, 8)}-${Date.now().toString(36)}`;
